import styled from '@emotion/styled'

const Option = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    & > p {
        font-size: 0.7em;
        font-weight: bold;
        justify-self: center;
    }
`

export { Option }
